module.exports = __webpack_public_path__ + "img/Cheer Megaphone09.91e143cb.jpg";